<template>
    <div class="word-detail common-detail">
        <div class="word-detail-banner">
            <div class="banner-content">
                <div class="left">
                    <div><span>Word批量<strong>超级</strong>大师</span></div>
                    <div></div>
                    <div>
                        <!-- <ul> -->
                            <li>安装即用，及其稳定</li>
                            <li>总计几十大类几百个功能</li>
                            <li>设置好任务后，一键自动处理，无需人工值守，几十万份文件自动处理完成！！！</li>
                            <li>可以任意多个功能组合处理，效率极高</li>
                            <li>只需注册一个账号，就可以在任意一台电脑登录使用！！！</li>
                            <li>无论office还是WPS，无版本要求，在任何一台电脑上安装即用，超级方便！！！</li>
                            <li>本软件速度实测是《Word文档批量处理大师》软件处理速度的20~50倍！！！</li>
                            <li>可以选套餐，也可以按功能付费，可以只购买需要的功能。</li>
                            <li>更多功能，请下载试用体验……</li>
                        <!-- </ul> -->
                    </div>
                    <div class="btns">
                        <a class="btn" :href="path + './soft/BatchWord_Super.rar'">立即试用</a>
                        <div @click="handle">视频教程</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="item1">
            <div class="item1-header">
                <div class="title">Word批量超级大师</div>
                <div class="sub-title">软件精致小巧，简单易用，针对性强，处理速度特别快。</div>
            </div>
            <div class="item1-wrapper">
                <div class="card" id="card1" :class="animateObj['#card1'] ? 'ani' : ''">
                    <div>多任务一次性批量处理</div>
                    <div>
                        <li>一次可以处理任意多个功能</li>
                        <li>每个功能都可以多次添加</li>
                        <li>几十大类功能，任意组合，效率特别高</li>
                        <li>所有任务都可以一键保存，导出和导入</li>
                        <li>大批量文件处理时，无需人工干预</li>
                    </div>
                </div>
                <div class="card" id="card2" :class="animateObj['#card2'] ? 'ani' : ''">
                    <div>从模板批量生成文件</div>
                    <div>
                        根据Excel数据和Word模板，批量创建Word新文件:
                        <li>根据提示即可完成操作，很简单</li>
                        <li>生成成绩单、通知书、工资条、证书</li>
                        <li>生成学生考试用桌贴，自定义尺寸</li>
                        <li>生成准考证、请柬、荣誉证书等</li>
                    </div>
                </div>
                <div class="card" id="card3" :class="animateObj['#card3'] ? 'ani' : ''">
                    <div>一键批量排版</div>
                    <div>
                        <li>设置指定段落的样式</li>
                        <li>特殊开头标记的段落的样式设置</li>
                        <li>整篇文档多个位置一键设定样式</li>
                        <li>支持正则表达式识别相应段落</li>
                    </div>
                </div>
                <div class="card" id="card4" :class="animateObj['#card4'] ? 'ani' : ''">
                    <div>内容批量替换</div>
                    <div>
                        <li>一次可以批量替换几十万个词条</li>
                        <li>支持正则表达式模糊替换</li>
                        <li>支持Excel导入/导出替换条件</li>
                        <li>支持仅指定位置替换，如：仅文本框内替换等</li>
                        <li>支持把文字替换为相应图片</li>
                        <li>支持删除文字所在段落等</li>
                    </div>
                </div>
                <div class="card" id="card5" :class="animateObj['#card5'] ? 'ani' : ''">
                    <div>超级清理</div>
                    <div>
                        快速批量清除文档中不需要的信息，如：
                        <li>页眉、页脚、水印、指定页、属性、隐藏文字</li>
                        <li>指定字号内容、超链接、电话号码、网址</li>
                        <li>图片、指定尺寸图片、指定段落、空白页</li>
                        <li>批注、脚注、尾注</li>
                        <li>强制移除编辑保护密码</li>
                        <li>强制移除内容保护密码</li>
                        <li>更多功能详见软件……</li>
                    </div>
                </div>
                <div class="card" id="card6" :class="animateObj['#card6'] ? 'ani' : ''">
                    <div>软件功能覆盖Word绝大多数常用功能</div>
                    <div>文件名的处理、表格的处理、Word转图片、转PDF等、图片的处理、合并文档、拆分文档、目录处理、转换文件类型、文档属性设置、文档信息统计及导出、提取电话号码等……</div>
                </div>
            </div>
        </div>
        <div class="item2">
            <div class="item2-wrapper">
                <div class="item2-title">产品优势</div>
                <ul class="list">
                    <li v-for="(item,index) in youshi" :key="index" :id="'item' + (index + 1)" :class="animateObj['#item' + (index + 1)] ? 'ani' : ''">
                        <div>{{item.title}}</div>
                        <div>{{item.intro}}</div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="item3">
            <div class="title" title="特别功能">特别功能</div>
            <div class="descri">(点击下面文字可以查看相应说明)</div>
            <ul>
                <li :class="activeIndex === index ? 'active' : ''" @click="turn(index)" v-for="(item,index) in spacialArr" :key="index">
                    <div class="first">
                        <div :title="item">{{item}}</div>
                    </div>
                </li>
            </ul>
            <div class="item3-content">
                <div class="main">
                    <div class="left">
                        <div style="margin-top:50px">{{spacialArr[activeIndex]}}</div>
                        <div v-html="introArr[activeIndex].intro"></div>
                        <div class="btn" style="margin-top:25px">
                            <!-- <el-button type="warning">点击试用</el-button> -->
                        </div>
                    </div>
                    <div class="right">
                        <img :src="introArr[activeIndex].img" alt="" @click="zoomIn(introArr[activeIndex].img)">
                    </div>
                </div>
            </div>
        </div>
        
        <div class="video-wrapper" v-if="showVideo">
            <div class="video-content">
                <div class="close"><i class="el-icon-error" @click="close"></i></div>
                <video-player  class="video-player vjs-custom-skin"
                    ref="videoPlayer"
                    :playsinline="true"
                    :options="playerOptions"
                ></video-player>
            </div>
        </div>
        <transition name="fade">
            <div class="mask" v-show="preShow" @click="zoomOut">
                <div class="img-main">
                    <img :src="preImg" alt="">
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
import { videoPlayer } from 'vue-video-player'
import 'video.js/dist/video-js.css'
export default {
    data(){
        return {
            preImg: '',
            preShow: false,
            path: process.env.BASE_URL,
            hezuo: [
                {
                    img: require('@/assets/hezuo/dz.gif'),
                    name: '河南省电子音像出版社'
                },
                {
                    img: require('@/assets/hezuo/zg.png'),
                    name: '中国教育出版网'
                },
            ],
            img2: require('@/assets/img_3.png'),
            sc: require('@/assets/icon_sc.png'),
            gl: require('@/assets/icon_gl.png'),
            ctb: require('@/assets/icon_ctb.png'),
            sg: require('@/assets/icon_sg.png'),
            xz: require('@/assets/cion_xz.png'),
            sjk: require('@/assets/icon_sjk.png'),
            zj: require('@/assets/icon_zj.png'),
            showVideo: false,
            playerOptions : {
                playbackRates: [0.7, 1.0, 1.5, 2.0], //播放速度
                autoplay: false, //如果true,浏览器准备好时开始回放。
                muted: false, // 默认情况下将会消除任何音频。
                loop: false, // 导致视频一结束就重新开始。
                preload: 'auto', // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
                language: 'zh-CN',
                aspectRatio: '16:9', // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
                fluid: true, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
                sources: [{
                src: `${process.env.BASE_URL}video/demo.mp4`,  // 路径
                type: 'video/mp4'  // 类型
                }],
                // poster: require('@/assets/logo.png'), //你的封面地址
                // width: document.documentElement.clientWidth,
                notSupportedMessage: '此视频暂无法播放，请稍后再试', //允许覆盖Video.js无法播放媒体源时显示的默认信息。
                controlBar: {
                timeDivider: true,
                durationDisplay: true,
                remainingTimeDisplay: false,
                fullscreenToggle: true  //全屏按钮
                }
            },
            youshi: [
                {
                    title: '灵活选择',
                    intro: '可以按套餐购买更优惠，也可以只购买需要的功能'
                },
                {
                    title: '多任务同时处理',
                    intro: '多任务集中处理，一次完成所有任务，效率高，处理速度更快。'
                },
                {
                    title: '无具体电脑限制',
                    intro: '使用注册的账号可以在任意一台电脑登录使用！！！'
                },
                {
                    title: '问题自动提示',
                    intro: '处理过程有提示，对于无法处理的文档进行标记，方便用户进行特殊处理'
                },
                {
                    title: '功能任意组合',
                    intro: '提供了几十大类批量任务选项，用户可自由选择、组合任意多个任务进行处理，功能极为强悍。'
                },
                {
                    title: '免费升级',
                    intro: '服务期内免费升级，可以使用到最新功能！！！'
                },
            ],
            spacialArr: ['从模板批量创建新文件','内容批量替换','word转图片或PDF','超级清理','文档属性设置及清除',
            '页面设置','批量打印','转换类型','页眉和页脚的设置','文件名的处理','表格批量处理','图片的处理','一键批量排版','一键提取电话、文档信息等','……'],
            introArr: [
                {
                    intro: '批量生成奖状、批量生成荣誉证书、批量生成工资条、批量生成贺卡、批量生成会议邀请函、批量生成录取通知书、批量生成商品邮寄广告、批量生成电话簿等',
                    img: require('@/assets/word/1.png')
                },
                {
                    intro: 'Word中的内容按指定的词条大批量替换，最多一次可以替换3万多个词条<br>支持把指定文字替换为指定的图片、word文档<br>支持Word域代码内容的替换、通配符的方式智能模糊查找替换<br>支持每一个词条替换后生成一个新的Word文件',
                    img: require('@/assets/word/2.png')
                },
                {
                    intro: 'Word批量转PDF<br>Word批量按页转图片',
                    img: require('@/assets/word/3.png')
                },
                {
                    intro: '通过本功能，您可以快速批量清除文档中不需要的信息，如：页眉、页脚、水印、指定页、属性、隐藏文字、指定字号内容、超链接、电话号码、网址、所有图片、指定尺寸的图片、指定段落、空白页、批注、脚注、尾注、强制移除编辑保护密码、强制移除内容保护密码等……',
                    img: require('@/assets/word/4.png')
                },
                {
                    intro: '一键批量设置所有文档的属性，包括自定义属性；一键清除所有属性',
                    img: require('@/assets/word/5.png')
                },
                {
                    intro: '设置页边距、装订线、纸张方向、纸张大小、页眉和页脚（支持奇偶页不同、首页不同）、页眉位置、背景纹理、背景颜色的设置与更改',
                    img: require('@/assets/word/6.png')
                },
                {
                    intro: '支持指定打印机、页码范围、追份，逐套打印等任务',
                    img: require('@/assets/word/7.png')
                },
                {
                    intro: '转换待处理文件列表中的所有文件为指定格式，如：转换为doc、docx格式、转换为RTF格式、转换为纯文本txt格式、转换为网页htm、html、mht格式等',
                    img: require('@/assets/word/8.png')
                },
                {
                    intro: '设置文字页脚、图片页眉、页脚的设置及清除等操作',
                    img: require('@/assets/word/9.png')
                },
                {
                    intro: '可以批量对文件名进行替换、插入字符、删除字符等操作',
                    img: require('@/assets/word/10.png')
                },
                {
                    intro: '可以设置指定位置的表格的样式，也可以只设定表格的行或者列的样式，以及单元格样式、更改指定单元格的内容，还可以从表格中提取数据保存到Excel中',
                    img: require('@/assets/word/11.png')
                },
                {
                    intro: '文档中图片的提取、添加、替换、删除、压缩、重设属性等；还可以指定图片的尺寸、删除图片所在段落等',
                    img: require('@/assets/word/12.png')
                },
                {
                    intro: '设定文档各部分内容的样式，一键批量排版',
                    img: require('@/assets/word/13.png')
                },
                {
                    intro: '从所有文档中批量一键提取电话号码、邮箱地址、IP地址等；一键进行信息统计及导出',
                    img: require('@/assets/word/14.png')
                },
            ],
            activeIndex: 0,
            animateObj: {
                '#card1': false,
                '#card2': false,
                '#card3': false,
                '#card4': false,
                '#card5': false,
                '#card6': false,
                '#item1': false,
                '#item2': false,
                '#item3': false,
                '#item4': false,
                '#item5': false,
                '#item6': false,
            }
        }
    },
    components: {
        videoPlayer
    },
    methods: {
        // 点击图片放大
        zoomIn(src){
            this.preImg = src;
            this.preShow = true;
        },
        // 点击图片缩小
        zoomOut(){
            this.preShow = false;
        },
        handle(){
            this.playerOptions.sources = [{
                src: `${this.path}video/productIntro/word.mp4`,  // 路径
                type: 'video/mp4'  // 类型
            }];
            this.showVideo = true;
        },
        toLook(){
            this.showVideo = true;
        },
        close(){
            this.showVideo = false;
        },
        turn(index){
            if(index !== this.spacialArr.length - 1){
                this.activeIndex = index;
            }
        },
        handleScroll () {
            this.preShow = false;
            // var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
            var w = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            for(var key in this.animateObj){
                var offsetTop = document.querySelector(key).getBoundingClientRect().top;
                if(offsetTop < w){
                    this.animateObj[key] = true;
                }else{
                    this.animateObj[key] = false;
                }
            }
        },
    },
    destroyed(){
        window.removeEventListener('scroll', this.handleScroll);
    },
    mounted(){
        window.addEventListener('scroll', this.handleScroll);
        this.handleScroll();
    }
}
</script>
<style lang="less">
    @import './css/product.less';
    .word-detail{
        .ani{
            transform: translateZ(0)!important;
            opacity: 1!important;
        }
        .mask{
            .img-main{
                img{
                    width: 100%;
                }
            }
        }
        .word-detail-banner{
            height: 730px;
            background: #198AF7 url('../assets/home_5.png') no-repeat center center;
            background-size: auto 100%;
            .banner-content{
                .title{
                    font-size: 40px;
                    color: #e79248;
                    margin-bottom: 10px;
                }
                .btn{
                    display: inline-block;
                    text-align: center;
                    font-size: 20px;
                    width:150px;
                    height:50px;
                    line-height: 50px;
                    border:1px solid rgba(255,255,255,1);
                    border-radius:25px;
                    margin-top: 20px;
                    cursor: pointer;
                    color: #fff;
                    text-decoration: none;
                    margin-right: 20px;
                    &:hover{
                        background-color: #f88927;
                        border-color: #f88927;
                    }
                }
                .left{
                    right: -160px;
                }
            }
        }
        .item1{
            width: 1200px;
            margin: 0 auto;
            height: 760px;
            display: flex;
            flex-direction: column;
            background: url('../assets/img_ji.png') no-repeat center center;
            .item1-header{
                text-align: center;
                padding-top: 60px;
                .title{
                    font-size: 40px;
                    color: #F88927;
                    margin-bottom: 10px;
                }
                .sub-title{
                    font-size: 18px;
                    color: #A9A9A9;
                }
            }
            .item1-wrapper{
                flex: 1;
                position: relative;
                .card{
                    position: absolute;
                    width: 312px;
                    transition: all 0.6s;
                    transform: translate3d(0,100px,0);
                    opacity: 0;
                    >div{
                        &:nth-of-type(1){
                            font-size: 24px;
                            text-align: right;
                        }
                        &:nth-of-type(2){
                            text-align: left;
                            font-size: 14px;
                            color: #A9A9A9;
                        }
                    }
                    &:nth-of-type(1){
                        top: 60px;
                        width: 295px;
                        left: 40px;
                    }
                    &:nth-of-type(2){
                        top: 260px;
                        width: 253px;
                        left: 4px;
                    }
                    &:nth-of-type(3){
                        top: 470px;
                        width: 261px;
                        left: 60px;
                    }
                    &:nth-of-type(4),&:nth-of-type(5),&:nth-of-type(6){
                        >div{
                            &:nth-of-type(1){
                                text-align: left;
                            }
                            &:nth-of-type(2){
                                text-align: left;
                            }
                        }
                    }
                    &:nth-of-type(4){
                        top: 70px;
                        left: 870px;
                    }
                    &:nth-of-type(5){
                        top: 260px;
                        left: 960px;
                    }
                    &:nth-of-type(6){
                        top: 470px;
                        left: 880px;
                    }
                    
                }
            }
        }
        .item6{
            background: url('../assets/img_lr.png') no-repeat center center;
            height: 750px;
            .item6-wrapper{
                width: 1200px;
                margin: 0 auto;
                padding: 70px 0;
                .item6-title{
                    font-size: 36px;
                    text-align: center;
                    color: #fff;
                    span{
                        color: #FFC446;
                    }
                }
                .item6-subtitle{
                    text-align: center;
                    color: #C9E9FF;
                    font-size: 18px;
                }
                .list-wrapper{
                    display: flex;
                    justify-content: space-around;
                    margin-top: 60px;
                    >div{
                        width:332px;
                        height:468px;
                        background:rgba(255,255,255,1);
                        box-shadow:0px 0px 18px 0px rgba(3, 136, 83, 0.35);
                        border-radius:8px;
                        box-sizing: border-box;
                        padding: 30px;
                        transition: all 0.6s;
                        transform: translate3d(0,100px,0);
                        opacity: 0;
                        .list-title{
                            font-size: 30px;
                            color: #F88927;
                            text-align: center;
                            margin-bottom: 20px;
                        }
                        ul{
                            color: #656666;
                            font-size: 16px;
                            li{
                                margin-bottom: 20px;
                                &::before{
                                    width:15px;
                                    height:15px;
                                    background:rgba(248,137,39,1);
                                    transform: rotate(50deg);
                                    content: '';
                                    display: inline-block;
                                    margin-right: 10px;
                                }
                            }
                        }
                    }
                }
            }
        }
        .item2{
            background: url('../assets/img_cpys.png') no-repeat center center;
            height: 655px;
            .item2-wrapper{
                width: 1200px;
                margin: 0 auto;
                .item2-title{
                    font-size: 36px;
                    color: #fff;
                    text-align: center;
                    padding: 40px 0;
                }
                .list{
                    display: flex;
                    flex-wrap: wrap;
                    box-sizing: border-box;
                    li{
                        transition: all 0.6s;
                        transform: translate3d(0,100px,0);
                        opacity: 0;
                        width:400px;
                        height:219px;
                        margin-right: -1px;
                        margin-bottom: -1px;
                        background:rgba(83,175,250,1);
                        border:1px solid rgba(255,255,255,1);
                        padding: 30px 40px;
                        box-sizing: border-box;
                        &:nth-of-type(2){
                            transition-delay: 0.3s;
                        }
                        &:nth-of-type(3){
                            transition-delay: 0.6s;
                        }
                        &:nth-of-type(5){
                            transition-delay: 0.3s;
                        }
                        &:nth-of-type(6){
                            transition-delay: 0.6s;
                        }
                        >div{
                            &:nth-of-type(1){
                                font-size: 24px;
                                color: #fff;
                                margin-bottom: 20px;
                            }
                            &:nth-of-type(2){
                                font-size: 18px;
                                color: #fff;
                            }
                        }
                    }
                }
            }
        }
        .item3{
            padding: 100px 0;
            width: 1200px;
            margin: 0 auto;
            .title{
                font-size: 36px;
                text-align: center;
                margin-bottom: 20px;
                color: #F88927;
            }
            .descri{
                 font-size: 18px;
                 text-align: center;
                 margin-bottom: 50px;
            }            
            ul{
                display: flex;
                flex-wrap: wrap;
                li{
                    width:122px;
                    height:122px;
                    box-sizing: border-box;
                    background:rgba(255,255,255,1);
                    box-shadow:0px 6px 18px 0px rgba(178,178,178,0.21);
                    border-radius:8px;
                    margin-right: 30px;
                    line-height: 122px;
                    margin-bottom: -20px;
                    transform: rotate(45deg) scale(0.8);
                    cursor: pointer;
                    &:nth-of-type(8){
                        margin-right: 0;
                    }
                    &:nth-of-type(9){
                        margin-left: 76px;
                    }
                    &:hover{
                        border: 1px solid #198AF7;
                        .first{
                            background:linear-gradient(17deg,rgba(71,179,246,1),rgba(25,138,247,1));
                            div{
                                color: #fff;
                            }
                        }
                    }
                    .first{
                        width: 120px;
                        height: 120px;
                        transform: scale(0.9);
                        margin: 0 auto;
                        border-radius:8px;
                        div{
                            transform: rotate(-45deg) scale(1.3);
                            text-align: center;
                            color: #546176;
                            font-size: 16px;
                            cursor: pointer;
                            user-select: none;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            width: 100%;
                            height: 100%;
                        }
                    }
                }
                .active{
                    border: 1px solid #198AF7;
                    .first{
                        background:linear-gradient(17deg,rgba(71,179,246,1),rgba(25,138,247,1));
                        div{
                            color: #fff;
                        }
                    }
                }
            }
            .item3-content{
                margin-top: 100px;
                background-color: #43AFF7;
                border-radius: 8px;
                box-shadow:0px 6px 18px 0px rgba(178,178,178,0.21);
                .main{
                    display: flex;
                    padding: 30px;
                    border-radius:8px;
                    transform: translateY(20px);
                    background-color: #fff;
                    box-shadow:0px 6px 18px 0px rgba(178,178,178,0.21);
                    .left{
                        flex: 1;
                        margin-right: 20px;
                        >div{
                            &:nth-of-type(1){
                                font-size: 24px;
                                margin: 30px 0;
                            }
                            &:nth-of-type(2){
                                font-size: 18px;
                                color: #8F8F8F;
                            }
                        }
                    }
                    .right{
                        flex: 1;
                        img{
                            width: 100%;
                            height: 336px;
                            object-fit: contain;
                        }
                    }
                }
            }
        }
        .item5{
            width: 1200px;
            margin: 0 auto;
            padding: 100px 0;
            .title{
                font-size: 36px;
                text-align: center;
                margin-bottom: 60px;
            }
            .list{
                display: flex;
                flex-wrap: wrap;
                .item{
                    width: 167px;
                    height: 197px;
                    padding: 20px;
                    box-sizing: border-box;
                    background:rgba(255,255,255,1);
                    box-shadow:0px 4px 16px 0px rgba(158,158,158,0.4);
                    margin-right: 91px;
                    margin-bottom: 38px;
                    transition: all 0.6s;
                    &:nth-of-type(5n){
                        margin-right: 0;
                    }
                    &:hover{
                        transform: scale(1.1);
                    }
                    .img{
                        width: 100px;
                        height: 100px;
                        margin: 0 auto;
                        img{
                            width: 100%;
                            height: 100%;
                        }
                    }
                    p{
                        margin-top: 5px;
                        text-align: center;
                        width: 100%;
                        // overflow: hidden;
                        // text-overflow: ellipsis;
                        // white-space: nowrap;
                    }
                }
            }
        }
        .video-wrapper{
            position: fixed;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
            background-color: rgba(0, 0, 0, 0.3);
            z-index: 9999;
            .video-content{
                position: absolute;
                top: 50%;
                left: 50%;
                width: 900px;
                transform: translate(-50%,-50%);
                .close{
                    text-align: right;
                    font-size: 50px;
                    color: #fff;
                    .el-icon-error{
                        cursor: pointer;
                    }
                }
                .video-player{
                    .vjs-big-play-button{
                        top: 50%;
                        left: 50%;
                        transform: translate(-50%, -50%);
                    }
                }
            }
        }
    }
</style>